<template>

	<div class="basic_wrap mt44" style="overflow: hidden;">
		<div class="red_top_bg">
            <div class="back_left" @click="$router.back()"></div>
            <div class="big_tit">{{$t('index.aboutUs')}}</div>
        </div>
		<div class="wrap_box">
			<router-link :to="'about/' + v.id" class="item" v-for="(v,k) in data.list" :key="k">
				{{v['title_'+lang]}}
			</router-link>
		</div>
	</div>
</template>

<script>
	import Fetch from '../../utils/fetch';
	import bsHeader from '../../components/bsHeader.vue'
	export default {
		name: "login",
		components: {
			bsHeader
		},
		data() {
			return {
				lang:this.$i18n.locale||"zh_cn",
				show_icon_type: 'about',
				data: {},
			};
		},
		created() {
			this.$parent.footer('user',false);
		},
		mounted() {
			this.start();
		},
		methods: {
			start() {
				Fetch('/index/about').then((r) => {
					this.data = r.data;
				});
			},
		}
	};
</script>

<style lang="less" scoped>
    .big_tit{
        position: absolute;
        height: 25px;
        font-size: 18px;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        line-height: 25px;
        top: 12px;
        left: 50%;
        transform: translateX(-50%);
    }
    .red_top_bg{
        position: fixed;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        z-index: 10;
    }
	.back_left {
		background: url(../../views/images/item/back.png) no-repeat center center;
        background-size: 50% 50%;
	}
	
	.wrap_box{
        
        display: flex;
        flex-direction: column;
        align-items: center;
        background: #2B3864;
        width: 95%;
        margin: 12px auto;
		.item{
			height: 50px;
			width: 95%;
			padding: 16px 0;
			border-bottom: 1px solid #3A4A7C;
			font-size: 14px;
			color: white;
			font-weight: 700;
			line-height: 20px;
			display: flex;
			justify-content: space-between;
		}
	}
</style>
